import { __assign } from 'tslib';
import { Language, currentFolderRootBreadcrumbContext } from '@keepeek/commons';
import { useRecoilValueLoadable, useRecoilValue, useRecoilState } from 'recoil';
import { LinkType } from '../../../KMosaic/KMosaicElement/index.props.js';
import { useBreadcrumb } from '../../breadcrumb/hooks.js';
import '../../breadcrumb/atoms.js';
import { mosaicPreloadingFolderIds, mosaicCurrentSelectedElement } from '../atoms.js';
import { mosaicFolderTreesSelector, mosaicElementsSelector } from '../selectors.js';

// Used for specific mosaic
var useMosaicWidget = function (_a) {
    var folderIds = _a.folderIds, mosaicElements = _a.mosaicElements, widgetId = _a.widgetId, _b = _a.countMedias, countMedias = _b === void 0 ? false : _b, clientIp = _a.clientIp, showSubFolderLink = _a.showSubFolderLink, setActiveFilters = _a.setActiveFilters, sentryCallback = _a.sentryCallback, _c = _a.currentLocale, currentLocale = _c === void 0 ? Language.Fr : _c;
    var calculatedFolderIds = [];
    if (folderIds && folderIds.length > 0) {
        calculatedFolderIds.push.apply(calculatedFolderIds, folderIds);
    }
    if (calculatedFolderIds.length === 0 && mosaicElements && mosaicElements.length > 0) {
        mosaicElements === null || mosaicElements === void 0 ? void 0 : mosaicElements.forEach(function (e) {
            if (e.linkType === LinkType.Folder && !!e.folderId) {
                calculatedFolderIds.push(e.folderId);
            }
        });
    }
    var foldersQuery = useRecoilValueLoadable(mosaicFolderTreesSelector({ folderIds: calculatedFolderIds }));
    var preloadingFolderIds = useRecoilValue(mosaicPreloadingFolderIds);
    var _d = useRecoilState(mosaicCurrentSelectedElement(widgetId)), currentSelectedId = _d[0], setCurrentSelectedId = _d[1];
    var _e = useRecoilState(currentFolderRootBreadcrumbContext), currentFodlerId = _e[0], setCurrentFolderId = _e[1];
    var folderTrees = foldersQuery.state === "hasValue" ? foldersQuery.contents : undefined;
    var loading = foldersQuery.state === "loading" ||
        preloadingFolderIds.some(function (id) { return calculatedFolderIds.includes(id); });
    var _f = useBreadcrumb({
        initFolderId: currentSelectedId,
        initFolderRootId: currentFodlerId,
        initialShowFolders: true,
        key: "useMosaic-".concat(widgetId),
        resetSearch: true,
        clientIp: clientIp,
        showSubFolderLink: showSubFolderLink,
        setActiveFilters: setActiveFilters,
        sentryCallback: sentryCallback
    }), folders = _f.folders, folderTree = _f.folderTree, foldersVisible = _f.foldersVisible, openFolder = _f.openFolder, search = _f.search, loadingFolderTree = _f.loading, handleFolderClick = _f.handleFolderClick;
    var elementsQuery = useRecoilValueLoadable(mosaicElementsSelector({ folderIds: calculatedFolderIds, countMedias: countMedias }));
    var elementsFolders = elementsQuery.state === "hasValue" ? elementsQuery.contents : [];
    var elements = elementsFolders;
    // Loop through mosaicElements and convert them to KpkMosaicElement
    if (!!mosaicElements && mosaicElements.length > 0) {
        elements = mosaicElements
            .map(function (e) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
            if (e.linkType === LinkType.Folder) {
                var elementFound = elementsFolders.find(function (el) { return el.id === e.folderId; });
                if (elementFound) {
                    return elementFound;
                }
                else {
                    return undefined;
                }
            }
            return __assign(__assign({}, e), { id: (_a = e.folderId) !== null && _a !== void 0 ? _a : -1, previewUrl: (_e = (_d = (_c = (_b = e.resource) === null || _b === void 0 ? void 0 : _b.find(function (elementResource) { return elementResource.language === currentLocale; })) === null || _c === void 0 ? void 0 : _c.resource) === null || _d === void 0 ? void 0 : _d.url) !== null && _e !== void 0 ? _e : "", href: (_h = (_g = (_f = e.href) === null || _f === void 0 ? void 0 : _f.find(function (elementHref) { return elementHref.language === currentLocale; })) === null || _g === void 0 ? void 0 : _g.value) !== null && _h !== void 0 ? _h : "", title: (_l = (_k = (_j = e.title) === null || _j === void 0 ? void 0 : _j.find(function (elementTitle) { return elementTitle.language === currentLocale; })) === null || _k === void 0 ? void 0 : _k.value) !== null && _l !== void 0 ? _l : "", partialLoading: false });
        })
            .filter(function (el) { return el !== undefined; });
    }
    var elementSelected = elements.find(function (el) { return el.id === currentSelectedId; });
    var handleHideButton = function () {
        setCurrentSelectedId(undefined);
    };
    var handleElementClick = function (element) {
        if (!element.linkType || element.linkType === LinkType.Folder) {
            var folderId_1 = element.id;
            if (folderId_1 === currentSelectedId) {
                setCurrentSelectedId(undefined);
                setCurrentFolderId(undefined);
            }
            else {
                setCurrentSelectedId(folderId_1);
                setCurrentFolderId(folderId_1);
                var selectedElements = elements.find(function (el) { return el.id === folderId_1; });
                if (selectedElements === null || selectedElements === void 0 ? void 0 : selectedElements.hasChildren) {
                    openFolder(folderId_1);
                }
                else if (selectedElements) {
                    search({
                        folderId: folderId_1,
                        extraParams: { fc: folderId_1 },
                        folderTitle: element.title,
                        treeMediaCount: element.treeMediaCount
                    });
                }
            }
        }
    };
    return {
        folderTrees: folderTrees,
        loading: loading,
        currentSelectedId: currentSelectedId,
        handleElementClick: handleElementClick,
        handleHideButton: handleHideButton,
        handleFolderClick: handleFolderClick,
        elements: elements,
        openFolder: openFolder,
        search: search,
        foldersVisible: foldersVisible,
        folderTree: folderTree,
        folders: folders,
        elementSelected: elementSelected,
        loadingFolderTree: loadingFolderTree
    };
};

export { useMosaicWidget };
//# sourceMappingURL=useMosaicWidget.js.map
